/**
 * returns script tag with videoObject metadata
 * @param   {object[] | object} data array or object with video metadata
 * @return {HTMLScriptElement}       videoObject metadata according to https://schema.org
 */
export default function VideoSchema({ data }) {
  function strip(html) {
    if (html == null) return "";

    const removeHTMLTags = html.replace(/<\/?[^>]+(>|$)/gm, "");
    const removeNewLine = removeHTMLTags.replace(/[\r\n]\s*[\r\n]/gm, "");
    return removeNewLine;
  }

  function toISODuration(time) {
    const [hours, mins, seconds] = time.split(":");

    if (hours != "0" && hours != "00") {
      return `PT${hours}H${mins}M${seconds}S`;
    } else {
      return `PT${mins}M${seconds}S`;
    }
  }

  function generateVideoSchema(item) {
    return {
      "@type": "VideoObject",
      name: strip(
        item.title || item.heading || item.video?.title || item.video?.heading
      ),
      description: strip(item.desc || item.video?.desc),
      uploadDate: item.video?.uploadDate || item.uploadDate,
      duration: toISODuration(item.video?.duration || item.duration),
      thumbnailUrl:
        item.video?.poster ||
        item.video?.preview ||
        item.poster ||
        item.preview,
      contentURL: item.video?.src || item.src,
      embedURL: `https://www.youtube.com/embed/${item.video?.id || item.id}`,
    };
  }

  let videoSchema = {};
  if (Array.isArray(data)) {
    videoSchema["@context"] = "http://schema.org";
    videoSchema["@type"] = "ItemList";
    videoSchema["itemListElement"] = [];
    data.map((item, count) => {
      const schemaItem = generateVideoSchema(item);
      schemaItem["position"] = count + 1;

      videoSchema["itemListElement"].push(schemaItem);
    });
  } else {
    videoSchema = generateVideoSchema(data);
    videoSchema["@context"] = "http://schema.org";
  }

  return (
    <script
      type="application/ld+json"
      id="videoSchema"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(videoSchema) }}
    ></script>
  );
}

/*
example video schema:
<script type="application/ld+json">
  {
    "@context": "https://schema.org",
    "@type": "VideoObject",
    "name": "Looking for ideas?",
    "description": "For inspiration to engage more customers, check out our latest blog.",
    "thumbnailUrl": "https://assets.setmore.com/website/v2/images/landing-pages/community/video-cover.webp",
    "uploadDate": "2021-08-17",
    "duration": "PT1M49S"
  }
</script>

*/
